var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total mb-3"},[_c('b-icon',{attrs:{"icon":"people-fill"}}),_vm._v(" "+_vm._s(_vm.models.length)+" 人 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }